import {
  BrandPowerStations,
  PowerStation,
  PowerStationInternal,
} from "../types/products";
import { buildProductRecord } from "../utils/products";

const brand = "Anker Solix";
const rawData: PowerStationInternal[] = [
  // Low DC
  {
    name: "C2000 Gen 2",
    amazon: {
      href: "https://www.amazon.com/dp/B0FVFGL38H/",
      affiliate: "https://amzn.to/3OFXNMw",
    },
    img: "/images/products/anker/c2000-gen-2/front-left.webp",

    price: 999,
    capacity: 2048,
    acOutput: 2400,
    dcOutput: 10,
    solar: 800,
    expandable: true,

    displayPowerSystemsPage: true,
  },
  {
    name: "F2000",
    amazon: {
      href: "https://www.amazon.com/dp/B09XM7WDZ2/",
      affiliate: "https://amzn.to/4cpdy29",
    },
    img: "/images/products/anker/f2000/front-right.webp",

    price: 899,
    capacity: 2048,
    acOutput: 2400,
    dcOutput: 10,
    solar: 1000,
    expandable: true,

    displayPowerSystemsPage: true,
  },
  {
    name: "C1000 Gen 2",
    amazon: {
      href: "https://www.amazon.com/dp/B0FN7MSY4L/",
      affiliate: "https://link.amazon/B0j4lmaTu",
    },
    img: "/images/products/anker/c1000-gen-2/front-right.webp",

    price: 550,
    capacity: 1024,
    acOutput: 2000,
    dcOutput: 10,
    solar: 600,

    displayPowerSystemsPage: true,
  },

  // High DC
  {
    name: "F3000",
    amazon: {
      href: "https://www.amazon.com/dp/B0F8BC2LFS/",
      affiliate: "https://amzn.to/4dTtSed",
    },
    img: "/images/products/anker/f3000/front-right.webp",

    price: 1399,
    capacity: 3072,
    acOutput: 3600,
    dcOutput: 30,
    solar: 1600,
    solar2: 800,
    expandable: true,

    displayPowerSystemsPage: true,
  },
];

const powerStations: BrandPowerStations = {
  name: brand,
  powerStations: buildProductRecord<PowerStationInternal, PowerStation>(
    rawData,
    brand
  ),
};

export default powerStations;
